<template>
  <currency-selection/>
</template>

<script>
import CurrencySelection from '../../components/Currency/Selection.vue';

export default {
  name: 'BaseCurrencyIndex',
  components: {
    CurrencySelection,
  },
};
</script>
